import React, { useEffect, useState } from 'react'
import parse from 'html-react-parser'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";

import axios from 'axios';
import { getBlogCategoryData, getBlogData, getLatestBlogData } from '../../../Redux/action/MasterAction';
import SkeletonLoaderBlogPage from '../../../Common/skeleton/Blog/SkeletonLoaderBlogPage';
import ResponsivePagination from '../../../Common/Pagination';
const host = process.env.REACT_APP_API_SERVER
const Blog = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(getBlogData(''));
        dispatch(getBlogCategoryData());
        dispatch(getLatestBlogData())
    }, []);


    const {
        loadingBlogDataListApi,
        BlogDataListApiData,
        BlogDataListApiError,

        loadingBlogCategoryDataListApi,
        BlogCategoryDataListApiData,
        BlogCategoryDataListApiError,


        loadingLatestBlogDataListApi,
        LatestBlogDataListApiData,
        LatestBlogDataListApiError,
    } = useSelector(state => state?.MasterReducer);



    const handleSearchChange = (e) => {
        const jobTitle = e.target.value;
        dispatch(getBlogData(jobTitle));
    };


    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const dataPerPage = 2;


    useEffect(() => {
        if (!BlogDataListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(BlogDataListApiData.slice(start, end));
        setPageCount(Math.ceil(BlogDataListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, BlogDataListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    const truncateText = (text, wordLimit) => {
        const normalizedText = text?.replace(/\s+/g, " ").trim();
        const words = normalizedText?.split(" ");

        if (words?.length > wordLimit) {
            return words.slice(0, wordLimit).join(" ") + "...";
        }
        return normalizedText;
    };


    const [expandedIndex, setExpandedIndex] = useState(null);

    const handleReadMoreClick = (index) => {
        setExpandedIndex(index);
    };

    const handleShowLessClick = () => {
        setExpandedIndex(null);
    };

    const [initialValues, setInitialValues] = useState({
        searchString: ""
    });

    // useFormik hook
    const formik = useFormik({
        initialValues: initialValues,

        onSubmit: async (values, { resetForm }) => {
            dispatch(getBlogData(values.searchString)); // Dispatch action with search string

        }
    });


    const handleNavigation =(slug)=>{
        navigate(`/blog-detail/${slug}`)
    }
   
    return (
        <div className='pagination-component'>
            <section className="blogs">
                <div className="container">
                    {loadingBlogDataListApi?
                    <SkeletonLoaderBlogPage/>
                    :
                        <div className="content" style={{ transform: "none", minHeight: 24 }}>
                        <div className="container-fluid" style={{ transform: "none" }}>
                            <div className="row" style={{ transform: "none" }}>
                                <div className="col-lg-8 col-md-12">


                                    {currentData?.map((data, index) => (
                                        <div className="blog" key={index} onClick={()=>{handleNavigation(data?.slug)}} style={{cursor:'pointer'}}>
                                            <div className="blog-image">
                                                <img
                                                    className="img-fluid"
                                                    src={data?.image ? `${host}${data?.image}` : ""}
                                                    alt="Post Image"
                                                />
                                            </div>
                                            <h3 className="blog-title">{data?.title}</h3>
                                            <div className="blog-info clearfix">
                                                <div className="post-left">
                                                    <ul>
                                                      
                                                        <li>
                                                            <i className="far fa-clock" />{new Date(data?.createdAt).toDateString()}
                                                        </li>
                                                       
                                                        <li>
                                                            <i className="fa fa-tags" />
                                                            {data?.category?.name}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="blog-content">
                                                {expandedIndex === index ? (
                                                    <>
                                                        {data?.description ? parse(data?.description) : ""}
                                                        <div className="read-btn d-flex justify-content-start">
                                                            <a
                                                                onClick={handleShowLessClick}
                                                                style={{ cursor: "pointer" }}
                                                                className="read-more"
                                                            >
                                                                Read Less
                                                            </a>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {data?.description
                                                            ? parse(truncateText(data?.description, 54))
                                                            : ""}
                                                        {data && data?.description.split(/\s+/).length > 54 &&
                                                            <div className="read-btn d-flex justify-content-start">
                                                                <a
                                                                    onClick={() => handleReadMoreClick(index)}
                                                                    style={{ cursor: "pointer" }}
                                                                    className="read-more"
                                                                >
                                                                    Read More
                                                                </a>
                                                            </div>}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}

                            

                                        {pageCount > 1 && (
                                            <ResponsivePagination
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                handlePageClick={handlePageClick}
                                            />
                                        )}

                                </div>
                                <div
                                    className="col-lg-4 col-md-12 sidebar-right theiaStickySidebar"
                                    style={{
                                        position: "relative",
                                        overflow: "visible",
                                        boxSizing: "border-box",
                                        minHeight: 1
                                    }}
                                >
                                    <div
                                        className="theiaStickySidebar"
                                        style={{
                                            paddingTop: 0,
                                            paddingBottom: 1,
                                            position: "static",
                                            transform: "none",
                                            top: 0,
                                            left: "1018.79px"
                                        }}
                                    >
                                        <div className="card search-widget blog">
                                            <div className="card-body">
                                                <form onSubmit={formik.handleSubmit} className="search-form">
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            placeholder="Search..."
                                                            className="form-control"
                                                            value={formik.values.searchString}
                                                            onBlur={formik.handleBlur}
                                                            onChange={formik.handleChange}
                                                            name="searchString" // Ensure you set name attribute to match initialValues
                                                        />
                                                        <button type="submit" className="btn btn-primary">
                                                            <i className="fa fa-search" />
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="card post-widget">
                                            <div className="card-header">
                                                <h4 className="card-title">Latest Posts</h4>
                                            </div>
                                            <div className="card-body">
                                                <ul className="latest-posts">
                                                    {LatestBlogDataListApiData?.map((data) => (
                                                        <Link to={`/blog-detail/${data?.slug}`}>
                                                            <li key={data?.id}>
                                                                <div className="post-thumb">
                                                                    <a>
                                                                        <img
                                                                            className="img-fluid"
                                                                            src={data?.image ? `${host}${data?.image}` : ""}
                                                                            alt=""
                                                                        />
                                                                    </a>
                                                                </div>
                                                                <div className="post-info">
                                                                    <h4>
                                                                        <a>
                                                                            {data?.title}
                                                                        </a>
                                                                    </h4>
                                                                    <p>{new Date(data?.createdAt).toDateString()}</p>
                                                                </div>
                                                            </li></Link>
                                                    ))}


                                                </ul>
                                            </div>
                                        </div>
                                        <div className="card category-widget mb-3">
                                            <div className="card-header">
                                                <h4 className="card-title">Blog Categories</h4>
                                            </div>
                                            <div className="card-body">
                                                <ul className="categories">
                                                    {BlogCategoryDataListApiData?.map((data) => (
                                                        <li key={data?.id}>
                                                            <a >
                                                                {data?.name} <span>({data?.blogCount})</span>
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </section>

        </div>
    )
}

export default Blog